export const normalizeOrganizationModelsV104 = (models) =>
  [
    ...new Set(
      (models || []).filter((model) => typeof model === 'string' && model)
    ),
  ].sort();

export const organizationModelRowsV104 = ({
  routableModels,
  knownModels = [],
  excludedModels,
  query = '',
  excluded = true,
}) => {
  const exclusions = new Set(excludedModels || []);
  const routable = new Set(routableModels || []);
  const search = query.trim().toLowerCase();
  return normalizeOrganizationModelsV104([
    ...(routableModels || []),
    ...knownModels,
    ...(excludedModels || []),
  ]).filter(
    (model) =>
      exclusions.has(model) === excluded &&
      (!excluded || routable.has(model)) &&
      model.toLowerCase().includes(search)
  );
};

export const setOrganizationModelExcludedV104 = (models, model, excluded) =>
  normalizeOrganizationModelsV104(
    excluded ? [...models, model] : models.filter((value) => value !== model)
  );

export const setOrganizationModelsExcludedV1013 = (
  exclusions,
  models,
  excluded
) => {
  const targets = new Set(normalizeOrganizationModelsV104(models));
  return normalizeOrganizationModelsV104(
    excluded
      ? [...exclusions, ...targets]
      : exclusions.filter((model) => !targets.has(model))
  );
};

export const organizationModelModeV104 = (mode, models, exclusions) =>
  mode === 'all_current' && !models.some((model) => exclusions.includes(model))
    ? 'all_current'
    : 'rules';

export const allowAllCurrentOrganizationModelsV104 = (models, exclusions) => {
  const current = new Set(models);
  return normalizeOrganizationModelsV104(
    exclusions.filter((model) => !current.has(model))
  );
};
